export default __webpack_public_path__ + "static/media/hht1_ep01_timeline_q03_a.085c3e07.png";